"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcRegisterSelector = class UcRegisterSelector extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    applySelection(...args) {
        const { selectedRegisterId, selectedVersionId } = this.value ?? {};
        if (args[0]) {
            let [{ register, version }] = args;
            if (!version) {
                version = _
                    .chain(register.versions.data)
                    .orderBy(['financial_year'], ['desc'])
                    .first()
                    .value();
            }
            if (selectedRegisterId != register.id ||
                selectedVersionId != version.id) {
                this.$emit('input', {
                    selectedRegisterId: register.id,
                    selectedVersionId: version.id
                });
            }
            return args[0];
        }
        this.$emit('input', {
            selectedRegisterId: null,
            selectedVersionId: null
        });
        return null;
    }
    selectByCache(...args) {
        const [registers, value] = args;
        const { selectedRegisterId, selectedVersionId } = value;
        if (selectedRegisterId && selectedVersionId) {
            let selection = null;
            for (let register of registers) {
                if (register.id == selectedRegisterId && register.versions) {
                    for (let version of register.versions.data) {
                        if (version.id == selectedVersionId) {
                            return { register, version };
                        }
                    }
                }
            }
        }
    }
    selectFirst(...args) {
        const [registers] = args;
        if (registers && registers.length) {
            for (let register of registers) {
                if (register.versions) {
                    for (let version of _.orderBy(register.versions.data, ['financial_year'], ['desc'])) {
                        return { register, version };
                    }
                }
            }
        }
    }
    value;
    onValue(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("value");
    }
    cacheKey;
    onCache_key(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("cacheKey");
    }
    companyId;
    onCompany_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("companyId");
    }
    variant;
    onVariant(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("variant");
    }
    toggleClass;
    onToggle_class(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("toggleClass");
    }
    registers;
    async $$load_registers() {
        return this.$fn.fetch('list_register', { parameters: { company_id: this.companyId } }).then(d => _.sortBy(d, 'name'));
    }
    selectedRegister;
    async $$load_selectedRegister() {
        return this.applySelection(this.selectByCache(this.$data.registers, this.value) || this.selectFirst(this.$data.registers));
    }
    ux;
    dataMembers = ['registers', 'selectedRegister', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                registers: null,
                selectedRegister: null,
                ux: null,
            },
        };
    }
    get noRegisterDefined() {
        if (this.loaded) {
            return !this.registers.length;
        }
        return null;
    }
    get dropdownToggleClass() {
        if (this.loaded) {
            return 'border ' + (this.toggleClass || '');
        }
        return null;
    }
    async act_5962862420439144_setData_8102_getActionArgs($event) {
        return {
            path: "selectedRegister",
            value: this.applySelection({ register: $event.scope.register }),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_5962862420439144_clickPrevent(event, scope) {
        return await this.actions.evh_5962862420439144_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_1048678296148443_showModal_8104_getActionArgs($event) {
        return {
            name: "Registers",
        };
    }
    async evh_1048678296148443_clickPrevent(event, scope) {
        return await this.actions.evh_1048678296148443_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_5974459770896956_setData_8108_getActionArgs($event) {
        return {
            path: "selectedRegister",
            value: this.applySelection({ register: this.selectedRegister.register, version: $event.scope.version }),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_5974459770896956_clickPrevent(event, scope) {
        return await this.actions.evh_5974459770896956_clickPrevent.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_5962862420439144_setData_8102 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5962862420439144_setData_8102_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_clickPrevent_8101 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_setData_8102,
            event: "click.prevent",
            displayName: "setData",
        });
        const evh_5962862420439144_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_clickPrevent_8101],
        });
        const act_1048678296148443_reloadComponentData_8106 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_1048678296148443_close_8105 = new core_1.actions.EventHandlerImpl({
            action: act_1048678296148443_reloadComponentData_8106,
            event: "close",
            displayName: "reloadComponentData",
        });
        const act_1048678296148443_showModal_8104 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_1048678296148443_showModal_8104_getActionArgs,
            events: [evh_1048678296148443_close_8105],
        });
        const evh_1048678296148443_clickPrevent_8103 = new core_1.actions.EventHandlerImpl({
            action: act_1048678296148443_showModal_8104,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_1048678296148443_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1048678296148443_clickPrevent_8103],
        });
        const act_5974459770896956_setData_8108 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5974459770896956_setData_8108_getActionArgs,
            events: [],
        });
        const evh_5974459770896956_clickPrevent_8107 = new core_1.actions.EventHandlerImpl({
            action: act_5974459770896956_setData_8108,
            event: "click.prevent",
            displayName: "setData",
        });
        const evh_5974459770896956_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5974459770896956_clickPrevent_8107],
        });
        return {
            act_5962862420439144_setData_8102,
            evh_5962862420439144_clickPrevent_8101,
            evh_5962862420439144_clickPrevent,
            act_1048678296148443_reloadComponentData_8106,
            evh_1048678296148443_close_8105,
            act_1048678296148443_showModal_8104,
            evh_1048678296148443_clickPrevent_8103,
            evh_1048678296148443_clickPrevent,
            act_5974459770896956_setData_8108,
            evh_5974459770896956_clickPrevent_8107,
            evh_5974459770896956_clickPrevent,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
        default: { "selectedRegisterId": null, "selectedVersionId": null },
    }),
    __metadata("design:type", Object)
], UcRegisterSelector.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRegisterSelector.prototype, "onValue", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcRegisterSelector.prototype, "cacheKey", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('cacheKey'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRegisterSelector.prototype, "onCache_key", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcRegisterSelector.prototype, "companyId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('companyId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRegisterSelector.prototype, "onCompany_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "light",
    }),
    __metadata("design:type", String)
], UcRegisterSelector.prototype, "variant", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('variant'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRegisterSelector.prototype, "onVariant", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcRegisterSelector.prototype, "toggleClass", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('toggleClass'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRegisterSelector.prototype, "onToggle_class", null);
UcRegisterSelector = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcRegisterSelector);
exports.default = UcRegisterSelector;
vue_property_decorator_1.Vue.component("UcRegisterSelector", UcRegisterSelector);
